import { ComponentCategory } from "../types";

// Category icons embedded as base64 data URIs (placeholder - replace with actual images)
export const CATEGORIES: ComponentCategory[] = [
  {
    id: "wheel-base",
    name: "Wheel Base",
    apiName: "wheel base",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FWheel%20Base-save.png&w=128&q=75",
  },
  {
    id: "wheel",
    name: "Wheel",
    apiName: "Wheel",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FWheel-save.png&w=64&q=75",
  },
  {
    id: "pedals",
    name: "Pedals",
    apiName: "Pedals",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FPedals-save.png&w=128&q=75",
  },
  {
    id: "cockpit",
    name: "Cockpit/Chassis",
    apiName: "Cockpit / Chassis",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FCockpit-save.png&w=128&q=75",
  },
  {
    id: "monitor-stand",
    name: "Monitor Stand",
    apiName: "Monitor Stand",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FMonitor%20Stand-save.png&w=128&q=75",
  },
  {
    id: "seat",
    name: "Seat",
    apiName: "Seat",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FSeat-save.png&w=128&q=75",
  },
  {
    id: "shifter",
    name: "Shifter",
    apiName: "Shifter",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FShifter-save.png&w=128&q=75",
  },
  {
    id: "handbrake",
    name: "Handbrake",
    apiName: "Handbrake",
    icon: "https://build.readysetsim.com/_next/image?url=%2Fimages%2Fcategory-icons%2FHandbrake-save.png&w=128&q=75",
  },
];

export const LOGO_BASE64 =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTgiIGhlaWdodD0iOTgiIHZpZXdCb3g9IjAgMCA5OCA5OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI0OSIgY3k9IjQ5IiByPSI0NSIgc3Ryb2tlPSIjZmYwMDAwIiBzdHJva2Utd2lkdGg9IjQiLz48L3N2Zz4=";
